<template>
    <section id="delivery">
        <div class="max-w-sm mx-auto">
            <delivery-address-form
                v-model="deliveryAddress"
                :error-handler="errorHandler"
                :showAddress = "showAddress"
                :display-plan-dropdown="true"
                :enable-delivery-waiting-list="enableDeliveryWaitingList"/>

            <div class="clear--sm"/>
        </div>

        <!-- <div class="pl-8 pr-8 pt-16 pb-20 divider--container background--paper-new">

            <div class="container mx-auto text-center">
                <img :src="getImagetUrl" alt="Delivery" class="inline-block w-32">
            </div>

            <div class="clear--xs"/>

            <div class="container mx-auto text-center max-w-md">
                <p v-if="deliveryDay && courierName"
                   v-html="$t('DELIVERY_FORM_YOUR_DELIVERIES', {deliveryDay: deliveryDay, courierName: courierDisplayName})"/>
                <p v-if="deliveryDay && deliveryAddress.city && !showDeliveryDaySelector"
                   v-html="$t('FRESH_DELIVERY_IN_YOUR_CITY', {deliveryDay: deliveryDay, city: deliveryAddress.city})"/>
                <p v-else-if="postcodeError" v-text="postcodeError"/>
                <p v-else-if="!deliveryDay" v-html="$t('DELIVERY_FORM_POP_IN')"/>
                <div class="day-select" v-if="showDeliveryDaySelector">
                    <p>{{ $t('DELIVERY_FORM_PREFERRED_DELIVERY_DAY') }}</p>
                    <multiselect
                        class="shop__menu-bar__sort shop__multiselect"
                        v-model="preferredDeliveryDay"
                        openDirection="below"
                        :searchable="false"
                        :show-labels="false"
                        :options="weekDayOptions"
                        :allow-empty="false"
                        />
                </div>
            </div>
        </div> -->

        <div class="max-w-sm mx-auto mt-12">
            <div v-if="allowFirstDateSelection">
                <delivery-day-field
                    v-model="selectedDeliveryDate"
                    :postcode="deliveryAddress.postcode"/>

                <!-- Small gap -->
                <div class="clear--sm"/>
            </div>

            <!--PropertyType-->
            <property-type-field
                v-model="propertyType"
                id="delivery_address_property_type"
                :mandatory="true"
                :is-valid="!errorHandler.has('delivery_address_property_type')"
                :message="errorHandler.get('delivery_address_property_type')"/>

            <!--Delivery comment-->
            <textbox-field
                :label="$t('DELIVERY_DAY_FIELD_WHERE_SHALL_WE')"
                id="delivery_instructions"
                :mandatory="true"
                :placeholder="$t('DELIVERY_INSTRUCTIONS_FIELD_PLEASE_POP')"
                :is-valid="!errorHandler.has('delivery_instructions')"
                :message="errorHandler.get('delivery_instructions')"
                v-model="deliveryComment"/>

            <div class="clear--sm"/>
            <div class="px-3 mb-4">
                <p v-html="$t('DELIVERY_ADDRESS_PROPERTY_FIELD_AND_FINALLY')"/>
            </div>

            <telephone-field
                v-model="telephone"
                id="telephone"
                :mandatory="true"
                :is-valid="!errorHandler.has('telephone')"
                :message="errorHandler.get('telephone')"
                :should-validate="true"/>

            <!-- <div v-if="isCanvasser">
                <checkbox
                    v-model="AddedAddonItem">
                    {{ $t('DELIVERY_ADDRESS_ADD_ON') }}
                 </checkbox>
                <img class="canvasser-addon" src="https://freddiesflowers-marketing-assets.s3.eu-west-2.amazonaws.com/images/Xmas+wreath/WREATH-CUT-OUT.jpg" alt="Paper background" />
            </div> -->
            <!-- Small gap -->
            <div class="clear--sm"/>

            <!-- Form button -->
            <div class="text-center">
                <submit-button
                    :processing="isFormProcessing"
                    color="green"
                    @click="submitCurrentStep()">
                    {{ $t('ACCOUNT_FORM_NEXT_STEP') }}
                </submit-button>
            </div>
        </div>
        <order-summary />
        <trust-pilot-review step="delivery"/>
        <div class="clear--sm"></div>
        <supported-cards />
        <div class="clear--sm"></div>
    </section>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { CANVASSER_TYPE } from '@/constants/Account';
import { SECTION_DELIVERY } from '@/constants/Registration';
import { isPostcodeFormatValid } from '@/helpers/PostcodeHelpers';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import RegistrationService from '@/services/users/RegistrationService';
import PostcodeService from '@/services/logistics/PostcodeService';
import TextboxField from '@/components/forms/fields/TextboxField';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import TelephoneField from '@/components/forms/fields/TelephoneField';
import DeliveryDayField from '@/components/forms/fields/DeliveryDayField';
import PropertyTypeField from '@/components/forms/fields/PropertyTypeField';
import DeliveryAddressForm from '@/components/forms/addresses/DeliveryAddressForm';
import IncompleteRegistrationService from '@/services/users/incompleteRegistrationService/IncompleteRegistrationService';
import { couriers } from '@/content/couriers';
import OrderSummary from '@/components/forms/fields/OrderSummary';
import SupportedCards from '@/components/forms/fields/SupportedCards';
import TrustPilotReview from '@/components/forms/fields/TrustPilotReview';
import Checkbox from '@/components/forms/fields/Checkbox';

export default {
    data: () => {
        return {
            postcodeError: null,
            isFormProcessing: false,
            showAddress: false,
            errorHandler: new ErrorResponseHandler(),
            weekDayOptions: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        };
    },
    props: {
        enableDeliveryWaitingList: {
            type: Boolean,
            default: false,
        },
        allowFirstDateSelection: {
            type: Boolean,
            default: false,
        },
        enableIncompleteRegistration: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        fetchDeliveryDateFromApi(postcode) {
            if (isPostcodeFormatValid(postcode)) {
                PostcodeService.GetFirstDeliveryDayForPostcode(postcode)
                    .then(response => {
                        const data = response.data.properties;
                        this.firstPossibleDeliveryDate = data.first_delivery_day;
                        this.courierName = data.courier_name;
                        this.preferredDeliveryDay = this.deliveryDay;
                    })
                    .catch(error => {
                        const response = error.response.data;

                        if (response.errors?.postcode) {
                            this.postcodeError = response.errors.postcode[0];
                        }
                    });
            }
        },

        submitCurrentStep() {
            this.isFormProcessing = true;

            if (this.enableIncompleteRegistration) {
                setTimeout(() => (new IncompleteRegistrationService()).updateOrCreate(), 0);
            }

            RegistrationService.validateDelivery()
                .then(() => {
                    this.isFormProcessing = false;
                    this.$store.commit('register/setSectionComplete', SECTION_DELIVERY);
                    this.$router.push({ name: this.nextRouteName });
                })
                .catch(error => {
                    this.showAddress = true;
                    this.errorHandler.setResponse(error.response && error.response.data);
                    this.isFormProcessing = false;
                    const errorElementsArray = Object.keys(this.errorHandler.response.errors);
                    const errorElementId = errorElementsArray.includes('delivery_address_postcode') ||
                        errorElementsArray.includes('delivery_address_line_1') ||
                        errorElementsArray.includes('delivery_address_city')
                        ? 'delivery_address_line_1' : errorElementsArray[0];
                    this.$scrollTo(`#${errorElementId}`, {
                        offset: -200,
                    });
                });
        },
    },
    computed: {
        showDeliveryDaySelector() {
            return process.env.VUE_APP_DELIVERY_DAY_SELECTOR && process.env.VUE_APP_DELIVERY_DAY_SELECTOR === 'true' && this.courierName === 'DPD';
        },
        getImagetUrl() {
            let name = couriers[this.courierName] ? couriers[this.courierName].icon : 'van';
            return require(`@/assets/images/decoration/icon-delivery-${name}.svg`);
        },
        deliveryAddress: {
            get() {
                return this.$store.getters['register/getDeliveryAddress'];
            },
            set(value) {
                this.$store.commit('register/setDeliveryAddress', value);
            },
        },
        deliveryDay() {
            if (this.showDeliveryDaySelector && this.preferredDeliveryDay) return this.preferredDeliveryDay;
            return this.$store.getters['register/getFirstDeliveryDay'];
        },
        firstPossibleDeliveryDate: {
            get() {
                return this.$store.getters['register/getFirstPossibleDeliveryDate'];
            },
            set(value) {
                this.$store.commit('register/setFirstPossibleDeliveryDate', value);
            },
        },
        courierName: {
            get() {
                return this.$store.getters['register/getCourierName'];
            },
            set(value) {
                this.$store.commit('register/setCourierName', value);
            },
        },
        courierDisplayName() {
            return couriers[this.courierName] ? couriers[this.courierName].displayName : this.courierName;
        },
        selectedDeliveryDate: {
            get() {
                return this.$store.getters['register/getFirstDeliveryDateDesired'];
            },
            set(value) {
                this.$store.commit('register/setFirstDeliveryDateDesired', value);
            },
        },
        deliveryComment: {
            get() {
                return this.$store.getters['register/getDeliveryComment'];
            },
            set(value) {
                this.$store.commit('register/setDeliveryComment', value);
            },
        },
        propertyType: {
            get() {
                return this.$store.getters['register/getPropertyType'];
            },
            set(value) {
                this.$store.commit('register/setPropertyType', value);
            },
        },
        telephone: {
            get() {
                return this.$store.getters['register/getTelephone'];
            },
            set(value) {
                this.$store.commit('register/setTelephone', value);
            },
        },
        nextRouteName() {
            return this.isInCanvassingMode ? 'canvasser-register.card-details' : 'register.card-details';
        },

        isInCanvassingMode() {
            return process.env.VUE_APP_MODE === CANVASSER_TYPE;
        },

        preferredDeliveryDay: {
            get() {
                return this.$store.getters['register/getPreferredDeliveryDay'];
            },
            set(value) {
                this.$store.commit('register/setPreferredDeliveryDay', value);
            },
        },
        isCanvasser() {
            return this.$store.getters['auth/isCanvasser'];
        },
        AddedAddonItem: {
            get() {
                return this.$store.getters['register/getAddedAddonItem'];
            },
            set(value) {
                this.$store.commit('register/setAddedAddonItem', value);
            },
        },
    },
    watch: {
        'deliveryAddress.postcode': {
            deep: true,
            handler: function(newPostcode, oldPostcode) {
                newPostcode = (newPostcode || '').toLowerCase();
                oldPostcode = (oldPostcode || '').toLowerCase();

                if ((oldPostcode !== newPostcode)) {
                    this.postcodeError = null;
                    this.firstPossibleDeliveryDate = null;
                    this.fetchDeliveryDateFromApi(newPostcode);
                }
            },
        },
    },
    components: {
        DeliveryAddressForm,
        TextboxField,
        PropertyTypeField,
        TelephoneField,
        SubmitButton,
        DeliveryDayField,
        OrderSummary,
        SupportedCards,
        TrustPilotReview,
        Multiselect,
        Checkbox,
    },
};
</script>
<style lang="scss" scoped>
.day-select {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
 }
 .canvasser-addon {
    max-width: 50%;
    height: auto;
    border: 2px solid;
    margin: auto;
 }
</style>
